import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import "../styles/orderSuccess.css";

export default function OrderSuccess({ cartCount, onCartClick }) {
  const location = useLocation();
  const navigate  = useNavigate();

  const order = (() => {
    if (location.state?.order) return location.state.order;
    try {
      const saved = sessionStorage.getItem("gvs_last_order");
      if (saved) return JSON.parse(saved);
    } catch {}
    return null;
  })();

  // Clear once shown so a later visit to /order-success doesn't show stale data
  React.useEffect(() => {
    sessionStorage.removeItem("gvs_last_order");
  }, []);

  return (
    <div className="order-success">
      <Navbar cartCount={cartCount} onCartClick={onCartClick} />

      <div className="order-success__body">
        {/* Icon */}
        <div className="order-success__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        <h1 className="order-success__title">Order Placed!</h1>

        {order && (
          <div className="order-success__card">
            <div className="order-success__row">
              <span className="order-success__label">Order Ref</span>
              <span className="order-success__value order-success__value--mono">
                {order.chargeId}
              </span>
            </div>
            <div className="order-success__row">
              <span className="order-success__label">Name</span>
              <span className="order-success__value">
                {order.firstName} {order.lastName}
              </span>
            </div>
            <div className="order-success__row">
              <span className="order-success__label">Mobile</span>
              <span className="order-success__value">{order.phone}</span>
            </div>
            <div className="order-success__row">
              <span className="order-success__label">Delivery</span>
              <span className="order-success__value">{order.deliverySummary}</span>
            </div>
            <div className="order-success__row order-success__row--total">
              <span className="order-success__label">Total</span>
              <span className="order-success__value">
                MK {Number(order.amount).toLocaleString()}
              </span>
            </div>
          </div>
        )}

        <button
          className="order-success__btn"
          onClick={() => navigate("/")}
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
}
